<script setup>
const selected = defineModel({
  type: Boolean,
  default: false,
})

defineProps({
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  label: {
    type: String,
    required: false,
    default: '',
  },
  itemId: {
    type: Number,
    required: false,
    default: null,
  },
})
</script>

<template>
  <button
    class="flex items-center gap-x-3 md:justify-center mt-5"
    :class="{
      'opacity-50 pointer-events-none': disabled,
    }"
  >
    <Checkbox :id="itemId" v-model="selected" />
    <label
      :for="itemId"
      class="text-secondary text-left font-semibold hover:cursor-pointer select-none"
      >{{ label }}</label
    >
  </button>
</template>
